import React from 'react';
import { Link } from 'react-router-dom';

const MissionVisionSection = () => {
  return (
    <div className="w-full px-4 py-16 md:py-24 bg-gray-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-12">
          {/* Mission Section */}
          <div className="relative h-full pt-14 md:pt-0">
            <div className="bg-white rounded-3xl p-6 pt-16 pb-8 relative h-full flex flex-col">
              <div className="absolute -top-14 md:-top-11 left-1/2 transform -translate-x-1/2">
                <div className="rounded-full bg-red-500 text-white px-8 md:px-5 py-6 md:py-5 font-bold text-lg md:text-xl text-center shadow-lg whitespace-nowrap">
                  Our Mission
                </div>
                <div className="w-6 h-6 bg-red-500 -mt-4 transform rotate-45 mx-auto mt-1"></div>
              </div>
              
              <div className="flex flex-col md:flex-row items-start gap-6 md:gap-8 mt-6 md:mt-4 flex-grow">
                <div className="flex-shrink-0 mx-auto md:mx-0 w-24 md:w-30 h-24 md:h-30">
                  <img src="/assets/game-icons_bullseye.svg" alt="Mission target" className="w-full h-full"/>
                </div>
                <div className="space-y-6 md:space-y-12 flex-grow">
                  <div className="flex items-start gap-3">
                    <span className="text-black font-bold text-lg mt-0.5">•</span>
                    <p className="text-gray-700 text-sm md:text-base">
                      To Promote Tamil culture, customs, language and traditions. To promote literature, art, drama and music (muthamil).
                    </p>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <span className="text-black font-bold text-lg mt-0.5">•</span>
                    <p className="text-gray-700 text-sm md:text-base">
                      To promote relationship with all functional Tamil Associations across Australia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vision Section */}
          <div className="relative h-full pt-14 md:pt-0">
            <div className="bg-white rounded-3xl p-6 pt-16 pb-8 relative h-full flex flex-col">
              <div className="absolute -top-14 md:-top-11 left-1/2 transform -translate-x-1/2">
                <div className="rounded-full bg-green-500 text-white px-8 md:px-6 py-6 md:py-5 font-bold text-lg md:text-xl text-center shadow-lg whitespace-nowrap">
                  Our Vision
                </div>
                <div className="w-6 h-6 bg-green-500 -mt-4 transform rotate-45 mx-auto mt-1"></div>
              </div>
              
              <div className="flex flex-col md:flex-row items-start gap-6 md:gap-6 mt-6 md:mt-4 flex-grow">
                <div className="flex-shrink-0 mx-auto md:mx-0 w-24 md:w-30 h-24 md:h-30">
                  <img src="assets/healthicons_eye-outline.svg" alt="Vision eye" className="w-full h-full"/>
                </div>
                <div className="space-y-6 flex-grow">
                  <div className="flex items-start gap-3">
                    <span className="text-black font-bold text-lg mt-0.5">•</span>
                    <p className="text-gray-700 text-sm md:text-base">
                      To unite the Tamil-speaking people living in South Australia under the Adelaide Tamil Association.
                    </p>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <span className="text-black font-bold text-lg mt-0.5">•</span>
                    <p className="text-gray-700 text-sm md:text-base">
                      To promote and foster understanding, friendship, goodwill and appreciation between Tamil Speaking community and cross-sections of various communities of South Australia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Join Community Button */}
        <div className="flex justify-center mt-12 md:mt-16">
          <Link
            to="/membership"
            className="group relative overflow-hidden px-6 md:px-8 py-3 md:py-4 border-orange-500
                     border-2 text-base md:text-lg font-medium rounded-lg 
                     transition-all duration-300 bg-white text-orange-500
                     hover:bg-orange-500 hover:text-white hover:border-orange-500 transform hover:-translate-y-1"
          >
            <span className="relative z-10">Join Our Community</span>
          </Link>
        </div>
        </div>
    </div>
  );
};

export default MissionVisionSection;